var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.6956H4C3.44772 22.6956 3 22.2479 3 21.6956V3.69556C3 3.14328 3.44772 2.69556 4 2.69556H20C20.5523 2.69556 21 3.14328 21 3.69556V21.6956C21 22.2479 20.5523 22.6956 20 22.6956ZM19 20.6956V4.69556H5V20.6956H19ZM7 6.69556H11V10.6956H7V6.69556ZM7 12.6956H17V14.6956H7V12.6956ZM7 16.6956H17V18.6956H7V16.6956ZM13 7.69556H17V9.69556H13V7.69556Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.970203856ff241e40379bfd00809fbfa.svg";
export { ForwardRef as ReactComponent };